import { createClient } from '@supabase/supabase-js';

const DEFAULT_SUPABASE_URL = 'https://sqvcbqgznlkphaqnsowh.supabase.co';
const DEFAULT_SUPABASE_ANON_KEY = 'sb_publishable_S4cayrKjIo-LB_qY6kJRow_9DQ_Tl2M';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || DEFAULT_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || DEFAULT_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
export const SUPABASE_ANON_KEY = supabaseAnonKey;

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storageKey: 'studiebijbaan.auth',
      },
    })
  : null;

export const getSupabaseSession = async () => {
  if (!supabase) return null;

  const code = new URLSearchParams(window.location.search).get('code');
  if (code) {
    const { error } = await supabase.auth.exchangeCodeForSession(code);
    if (error) {
      console.error('Supabase auth code exchange failed:', error.message);
    }
  }

  const { data, error } = await supabase.auth.getSession();
  if (error) {
    console.error('Supabase session lookup failed:', error.message);
    return null;
  }

  return data.session;
};

export const refreshSupabaseSession = async () => {
  if (!supabase) return null;

  const { data, error } = await supabase.auth.refreshSession();
  if (error) {
    console.error('Supabase session refresh failed:', error.message);
    return null;
  }

  return data.session;
};

export default supabase;
